module.exports = __webpack_public_path__ + "images/dingtalk/icon-project-6e33a2fe1488881259d4178a0b089712.png";